"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.datoToBRICKS = void 0;
var _lodash = require("lodash");
const mapDatoToBRICKS = [{
  bricksKey: 'Paragraph',
  possibleKeys: ['DatoCmsParagraph', 'ParagraphRecord']
}, {
  bricksKey: 'Quote',
  possibleKeys: ['DatoCmsQuote', 'QuoteRecord']
}, {
  bricksKey: 'CustomHtml',
  possibleKeys: ['DatoCmsCustomMarkup', 'CustomMarkupRecord']
}, {
  bricksKey: 'Loader',
  possibleKeys: ['DatoCmsLoader', 'LoaderRecord']
}, {
  bricksKey: 'Gallery',
  possibleKeys: ['DatoCmsGallery', 'GalleryRecord']
}, {
  bricksKey: 'Separator',
  possibleKeys: ['DatoCmsSeparator', 'SeparatorRecord']
}, {
  bricksKey: 'Hero',
  possibleKeys: ['DatoCmsHero', 'HeroRecord']
}, {
  bricksKey: 'Headline',
  possibleKeys: ['DatoCmsHeadline', 'HeadlineRecord']
}, {
  bricksKey: 'Images',
  possibleKeys: ['DatoCmsImages', 'ImagesRecord', 'DatoCmsImage', 'ImageRecord']
}, {
  bricksKey: 'Interview',
  possibleKeys: ['DatoCmsInterview', 'InterviewRecord']
}, {
  bricksKey: 'Video',
  possibleKeys: ['DatoCmsVideo', 'VideoRecord']
}, {
  bricksKey: 'Marquee',
  possibleKeys: ['DatoCmsMarquee', 'MarqueeRecord']
}, {
  bricksKey: 'Credits',
  possibleKeys: ['DatoCmsCredit', 'CreditRecord']
}, {
  bricksKey: 'CTA',
  possibleKeys: ['DatoCmsCTA', 'CTARecord', 'CtaRecord', 'DatoCmsCta']
}, {
  bricksKey: 'SVG',
  possibleKeys: ['DatoCmsSVG', 'SVGRecord', 'SvgRecord', 'DatoCmsSvg']
}, {
  bricksKey: 'Cta',
  possibleKeys: ['DatoCmsCTA', 'CTARecord', 'CtaRecord', 'DatoCmsCta']
}, {
  bricksKey: 'ShoppingCarousel',
  possibleKeys: ['DatoCmsShoppingCarousel', 'ShoppingCarouselRecord']
}, {
  bricksKey: 'AgeGate',
  possibleKeys: ['DatoCmsAgeGate', 'AgeGateRecord']
}, {
  bricksKey: 'Imagetext',
  possibleKeys: ['DatoCmsImagetext', 'ImagetextRecord']
}, {
  bricksKey: 'ArticleAggregator',
  possibleKeys: ['DatoCmsArticleAggregator', 'ArticleAggregatorRecord']
}, {
  bricksKey: 'ProgressBar',
  possibleKeys: ['DatoCmsProgressBar', 'ProgressBarRecord']
}, {
  bricksKey: 'FieldsForm',
  possibleKeys: ['DatoCmsFieldsForm', 'FieldsFormRecord']
}];
const datoToBRICKS = ({
  content
}) => {
  const storyContent = [];
  let currentLayout = null;
  (0, _lodash.forEach)(content, (item, index) => {
    const t = item.__typename;
    if ((0, _lodash.includes)(t, 'Layout')) {
      currentLayout = currentLayout === null ? 0 : currentLayout + 1;
      let layout = {
        data: {
          ...(0, _lodash.omit)(item, ['id', '__typename']),
          sectionType: item.layoutType || 'Simple'
        },
        elements: [],
        id: item.sectionId || `section--${currentLayout}`
      };
      if (item.backgroundImage) {
        layout.data.backgroundImage = item.backgroundImage?.responsiveImage || item.backgroundImage?.fluid;
      }
      storyContent.push(layout);
    } else {
      if (index === 0) {
        currentLayout = 0;
        const layout = {
          type: 'Simple',
          data: {
            sectionType: item.layoutType || 'Simple'
          },
          elements: [],
          id: `section--${currentLayout}`
        };
        storyContent.push(layout);
      }
      let elType = null;
      (0, _lodash.forEach)(mapDatoToBRICKS, k => {
        if ((0, _lodash.includes)(k.possibleKeys, t)) {
          elType = k.bricksKey;
        }
      });
      let element = {
        type: elType,
        data: (0, _lodash.omit)(item, ['__typename', 'id'])
      };
      if (item.backgroundImage) {
        element.data.backgroundImage = item.backgroundImage.responsiveImage || item.backgroundImage.fluid;
      }
      if (item.svgPortrait) {
        element.data.svgPortrait = item.svgPortrait.url;
      }
      if (item.svgLandscape) {
        element.data.svgLandscape = item.svgLandscape.url;
      }
      if (item.items) {
        element.data.items = (0, _lodash.map)(item.items, it => {
          return it.fluid || it.responsiveImage;
        });
      }
      if (item.images) {
        element.data.images = (0, _lodash.map)(item.images, it => it.fluid || it.responsiveImage);
        if (item.images?.length > 0 && elType === 'Images') {
          element.data.images = item.images.map(imageObject => {
            return {
              ...imageObject,
              image: imageObject.image.fluid || imageObject.image.responsiveImage,
              svg: imageObject.svg?.url
            };
          });
        }
      }
      if (element.type !== null) {
        storyContent[currentLayout].elements.push(element);
      } else {
        console.log('No matching element type found for ', item, t, mapDatoToBRICKS);
      }
    }
  });
  return storyContent;
};
exports.datoToBRICKS = datoToBRICKS;
var _default = datoToBRICKS;
exports.default = _default;
//# sourceMappingURL=dato-to-bricks.js.map